import { AppBar, Toolbar, Typography, Button, Box, Link} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';


export const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isOnUploadPage = location.pathname.includes('upload');
  const base = process.env.PUBLIC_URL || '';
  const home = base + '/#/';
  const upload = base + '/#/upload';

  return (
    <AppBar position="static" color="transparent" sx={{ marginBottom: 1, bgcolor: 'white', boxShadow: 0 }}>
      <Toolbar>
        <Link href={home} color="inherit" underline="none">
          <Typography variant="h6"
            sx={{
              color: '#f00020'
            }}
            component="div">
            <Box
              sx={{
                verticalAlign: 'middle',
                paddingLeft: '5px',
                height: '30px',
              }}
              component="img"
              height="46"
              alt=""
              src="otto.svg"
            />
            Share Your Secret
          </Typography>
        </Link>
        <Box
          sx={{
            marginLeft: 'auto',
          }}
        >
          <Button
            component={Link}
            href={isOnUploadPage ? home : upload}
            variant="contained"
            color="primary"
          >
            {isOnUploadPage ? t('header.buttonHome') : t('header.buttonUpload')}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
